module.exports = __webpack_public_path__ + "media/src/assets/Images/Telephone-e4528795e45cadfb5584d8e96d55ca7a.svg";